export const NOT_APPLICABLE = 'N/A';
